import { create } from 'zustand';

type UiState = {
  menuOpen: boolean;
  lineageId: string | null;
  bentoId: string | null;
  galleryIndex: number | null;
  toggleMenu: () => void;
  closeMenu: () => void;
  openLineage: (id: string) => void;
  openBento: (id: string) => void;
  openGallery: (index: number) => void;
  closeOverlays: () => void;
  reset: () => void;
};

const initialState = { menuOpen: false, lineageId: null, bentoId: null, galleryIndex: null };

export const useUiStore = create<UiState>((set) => ({
  ...initialState,
  toggleMenu: () => set((state) => ({ menuOpen: !state.menuOpen })),
  closeMenu: () => set({ menuOpen: false }),
  openLineage: (lineageId) => set({ ...initialState, lineageId }),
  openBento: (bentoId) => set({ ...initialState, bentoId }),
  openGallery: (galleryIndex) => set({ ...initialState, galleryIndex }),
  closeOverlays: () => set({ lineageId: null, bentoId: null, galleryIndex: null }),
  reset: () => set(initialState),
}));
